import {useState} from 'react';
import ReactHowler from 'react-howler'
import ScreenPieces from './ScreenPieces';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import ImagePreview from '../Show/ImagePreview';

const Chart = (props) => {

  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var overallWidth = props.overallWidth;
  var height = props.height;
  var inputValues = props.inputValues;
  var setInputValues = props.setInputValues;
  var ownVariables = props.ownVariables;
  var musicStatus = props.musicStatus;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var alertVisibility = props.alertVisibility;
  var interactionFn = props.interactionFn;
  var overlays = props.overlays;
  var screenRefs = props.screenRefs;
  var setScreenRefs = props.setScreenRefs;
  var whichFEOrPU = props.whichFEOrPU;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var offsetLeft = props.offsetLeft;
  var offsetTop = props.offsetTop;
  var chains = props.chains;

  const [screenSelectionChoices, setScreenSelectionChoices] = useState({});

  var oStyle = {width, height, verticalAlign:'top', position:'relative', textAlign:'center'};
  var style = {width, height, overflowY:'scroll', position:'relative', zIndex:1};

  var itemEdited = false;
  var organicChanges = false;
  var setItemEdited = false;
  var refObject = false;
  var onClickItemChangeSelection = false;
  var error = false;
  var otherPeoplesPositions = [];
  var updatesToPropagate = false;
  var getRef1 = false;
  var userNos = -1;
  var userID = -1;
  var lastEdited = '';

  var scale = width / overallWidth;

  var processedItems = <ScreenPieces chains={chains} scale={scale} actualWidth={width} overallWidth={width} insetWidth={width} insetHeight={height} currentList={currentList} organicChanges={organicChanges} itemEdited={itemEdited} setItemEdited={setItemEdited} whichFEOrPU={whichFEOrPU} onClickItemChangeSelection={onClickItemChangeSelection} otherPeoplesPositions={otherPeoplesPositions} internalVariables={internalVariables} updatesToPropagate={updatesToPropagate} error={error} refObject={refObject} getRef1={getRef1} inputValues={inputValues} setInputValues={setInputValues} ownVariables={ownVariables} alertVisibility={alertVisibility} interactionFn={interactionFn} isShowingSomeDropDown={false} setIsShowingSomeDropDown={false} bottomBit={overlays} style={style} className='' userNos={userNos} userID={userID} setIsClickingOnContentDiv={false} isClickingOnContentDiv={false} screenRefs={screenRefs} setScreenRefs={setScreenRefs} addWhereText='' potentiallyAddWhichItem={false} changeTab={false} tabSelected={false} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} hidePanelRelativeItems={{}} flashHighlight={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} reportPageHeight={false} offsetTop={offsetTop} offsetLeft={offsetLeft} lastEdited={lastEdited} counter={0}/>
//  
  var popUp;
  if (popUps.length > 0){
    var puVSet = popUps[popUps.length - 1];
    var ins;
    var backgroundColor = 'rgba(0, 0, 0, 0.8)';
    if (puVSet.t === 'normal'){
      var puV = puVSet.v;
      var upwardInfo = [];
      var pageS = StyleFunctions.evaluateStyleR('PAGE', currentList.pu[puV].s, ['pu', puV, 's'], currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      var popUpPadding = pageS.popUpPadding;
      backgroundColor = StyleFunctions.combineRGBAndOpacity(pageS.backgroundColor, pageS.paddingOpacity);

      var styleIn = {maxWidth:width, maxHeight:height - 2 * popUpPadding, overflow:'scroll', position:'relative'};
      var actWidth = ResponsiveFns.resolveSingular(pageS.w, width, height);

      ins = <ScreenPieces chains={chains} scale={1} actualWidth={actWidth} overallWidth={width} insetWidth={width} insetHeight={height} currentList={currentList} organicChanges={organicChanges} itemEdited={itemEdited} setItemEdited={setItemEdited} whichFEOrPU={{t:'pu',v:puV}} onClickItemChangeSelection={onClickItemChangeSelection} otherPeoplesPositions={otherPeoplesPositions} internalVariables={internalVariables} updatesToPropagate={updatesToPropagate} error={error} refObject={refObject} getRef1={getRef1} inputValues={inputValues} setInputValues={setInputValues} ownVariables={ownVariables} alertVisibility={alertVisibility} interactionFn={interactionFn} isShowingSomeDropDown={false} setIsShowingSomeDropDown={false} bottomBit={overlays} style={styleIn} className='' userNos={userNos} userID={userID} setIsClickingOnContentDiv={false} isClickingOnContentDiv={false} screenRefs={screenRefs} setScreenRefs={setScreenRefs} addWhereText='' potentiallyAddWhichItem={false} changeTab={false} tabSelected={false}  screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} hidePanelRelativeItems={{}} flashHighlight={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} reportPageHeight={false} offsetTop={offsetTop} offsetLeft={offsetLeft} lastEdited={lastEdited} counter={0}/>
    }else{
      var srcList = puVSet.srcList;
      ins = <ImagePreview srcList={srcList} item={puVSet.item} popUps={popUps} setPopUps={setPopUps} mvtIcon={puVSet.mvtIcon} buttonsOutside={puVSet.buttonsOutside}/>
    }
//    
    var popUpStyle = {position:'absolute', left:0, top:0, zIndex:1500, right:0, bottom:0, backgroundColor, verticalAlign:'middle'};
    popUp = <div style={popUpStyle}><table style={{width, height}}><tbody><tr><td>{ins}</td></tr></tbody></table></div>
//
  }

  var musicPieces;
  if (currentList.mu){
    var musicKeys = Object.keys(currentList.mu);
    musicPieces = musicKeys.map((aMusicKey, index)=>{
      var isPlaying = musicStatus[aMusicKey];
      var thisPiece = currentList.mu[aMusicKey];
      var url = thisPiece.src;
      return <ReactHowler key={index} src={url} playing={isPlaying}/>
    })
  }

  return (<div style={oStyle} >
            {musicPieces}
            {processedItems}
            {popUp}
          </div>
  );
};

export default Chart;